export default {

    methods: {
        uploadConfig({advertisingId, file}) {
            const data = new FormData()
            data.append('file', file)

            if (!file)
                return

            this.$api.locals.uploadConfig({advertisingId, data})
        }
    },

}
